<template>
    <div>
        <div class="h1" >
        </div>
        <div>
            <img @click="to_api()" style="width: 100%;height: 3.54rem;" src="../assets/imgs/tck/免费领取.gif" alt="">
        </div>
    </div>
</template>
<!-- mounted() {
    this.adid = this.$route.query.adid
    this.creativeid = this.$route.query.creativeid
    this.creativetype = this.$route.query.creativetype
    this.clickid = this.$route.query.clickid
    this.code = this.$route.query.code
    if (this.$route.query.adid == undefined) {
        this.adid = null
    }
    if (this.$route.query.creativeid == undefined) {
        this.creativeid = null
    }
    if (this.$route.query.creativetype == undefined) {
        this.creativetype = null
    }
    if (this.$route.query.clickid == undefined) {
        this.clickid = null
    }
}, -->
<script>
import axios from "axios"
// import { testdata } from '@/api/userApi.js'
export default {
    data() {
        return {
            adid: "",
            creativeid: "",
            creativetype: "",
            clickid: ""
        }
    },
    mounted() {
        this.adid = this.$route.query.adid
        this.creativeid = this.$route.query.creativeid
        this.creativetype = this.$route.query.creativetype
        this.clickid = this.$route.query.clickid
		this.addEnter()
    },
    methods: {
		addEnter(){
			let data = {
			              code: this.$route.query.code,
			          }
		
			          axios({
			              method: "GET",
			              url: "https://dy01.txcfgl.net:10081/v1/clutter/dataEnter?livecode=ca_140"
			              // url: "http://172.18.2.154:8080/v1/applet/getUrl?adid=" + data.adid + "&creativeid=" + data.creativeid + "&creativetype=" + data.creativetype + "&clickid=" + data.clickid + "&code=" + data.code,
			          }).then(res => {
			          })
		},
        to_api() {
            let data = {
                adid: this.adid,
                creativeid: this.creativeid,
                creativetype: this.creativetype,
                clickid: this.clickid,
                code: this.$route.query.code,
            }
            axios({method: "GET",url:'https://dy01.txcfgl.net:10081/v1/clutter/resourcesCheck?livecode=ca_140'}).then(res=>{
            	if(res.data.data==1){
            		if(data.clickid!=undefined){
            				var length=data.clickid.slice(46,76);
            				window.location.href ="https://work.weixin.qq.com/ca/cawcdea01f340e46a1?customer_channel=ca_140_"+length
            			}else{
            				window.location.href ="https://work.weixin.qq.com/ca/cawcdea01f340e46a1?customer_channel=ca_140"
            			}
            		
            	}else{
            		window.location.href ="https://www.txcfgdd666.com/kongbai"
            	}
            })
            
        },
    },

}
</script>

<style>
.h1 {
    width: 100%;
    height: 7.8rem;
    background: url(../assets/imgs/tck/落地页-题材库.jpg);
    background-size: 100% 100%;
}

.imgs {
    padding-left: .5rem;
    padding-top: 7.83rem;
}

img {
    width: 6.5rem;
    height: 1.30rem;
}
</style>